import Persist from './persist';

// Local scope ==================================
const utils = {};

utils.persist = Persist;

// Capitalize first letters in every word =======
utils.capPhrase = (phrase) => phrase.replace(/_/g, ' ').replace(/\b[a-z](?=[a-z]{2})/g, letter => letter.toUpperCase());

// Format to money ==============================
utils.formatMoney = (num) => num.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');

// Rand!! wee! ==================================
utils.rand = () => (Math.random().toString(36) + '00000000000000000').slice(2, 8 + 2);


utils.roundNumber = (num) => Math.round(num * 100) / 100;

// Format numbers with commas ===================
utils.numberWithCommas = (num) => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

// Add st, nd, rd and th (ordinal) suffix to a number
utils.ordinalSuffixOf = (i) => {

  const j = i % 10;
  const k = i % 100;

  if (j === 1 && k !== 11) {
    return i + 'st';
  }

  if (j === 2 && k !== 12) {
    return i + 'nd';
  }

  if (j === 3 && k !== 13) {
    return i + 'rd';
  }

  return i + 'th';
};

// Search a JSON for specific Keys/Vals =========
utils.searchJSON = (obj, key, val) => {

  let objects = [];

  for (const i in obj) {
    if (!obj.hasOwnProperty(i)) {
      continue;
    }
    if (typeof obj[i] === 'object') {
      objects = objects.concat(utils.searchJSON(obj[i], key, val));
    } else if (i === key && obj[i] === val || i === key && val === '') {
      // if key matches and value matches or if key matches and value is not passed (eliminating the case where key matches but passed value does not)
      objects.push(obj);
    } else if (obj[i] === val && key === '') {
      // only add if the object is not already in the array
      if (objects.lastIndexOf(obj) === -1) {
        objects.push(obj);
      }
    }
  }

  return objects;
};

utils.formatOnly = (input, inputFilter) => {
  ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach( (event) => {
    input.addEventListener(event, () => {
      if (inputFilter(input.value)) {
        input.oldValue = input.value;
        input.oldSelectionStart = input.selectionStart;
        input.oldSelectionEnd = input.selectionEnd;
      } else if (input.hasOwnProperty('oldValue')) {
        input.value = input.oldValue;
        input.setSelectionRange(input.oldSelectionStart, input.oldSelectionEnd);
      }
    });
  });
};

/* ========================================================
  Function Nullable Validator

  @obj = variable ( Any Type except Boolean ).
  @defaultValue = this will be returned in case that @obj is null, false, undefined or empty string. ( Any Type )
  @key = it depends if it is an Array or an Object . ( Type String )

    Examples:
     Array :     nullValidator([27,54,18], 'sorry the value is not there', '3'); // this will return '18'
     Object:     nullValidator({ user: { fistName: 'John', lastName: 'Doe'} }, 'not found', 'user.firstName'); // returns 'John'
     String:     nullValidator('Hello World','Oppps!'); // this will print return 'Hello World'
     Number:     nullValidator(254,'Oppps!'); // returns '254'
     Null Value: nullValidator('','Oppps!'); // this will print return 'Oppps!'

   ======================================================== */

utils.nullValidator = (obj, defaultValue, key = '') => {
  return ( (typeof obj === 'object') ? key.split('.').reduce((o, x) => {
    return (typeof o === 'undefined' || o === null) ? o : o[x];
  }, obj)  : obj ) || defaultValue;
};

/* Converts an Object to a CSS String ====================
  const classes = {
    'active': true,
    'foo': false,
    'bar': true,
  };

  util.classHelper(classes); // 'active bar'
*/
utils.classHelper = (obj) => (
  Object.keys(obj)
    .filter(attribute => obj[attribute])
    .join(' ')
    .trim()
);
// Converts an Object to a String Parameters ====================
utils.toParam = (obj) => Object.keys(obj).map(key => `${key}=${obj[key]}`).join('&');
// Get Items from localStorage ==================
utils.getLocalStorageCart = () => {

  let storage = {};
  let result = [];

  if ('cart' in localStorage) {
    storage = JSON.parse(localStorage.cart);
  }

  result = ('items' in storage) ? storage.items : [];

  return result;
};

// Set Items to LocalStorage ====================
utils.setLocalStorageCart = (items) => {

  localStorage.cart = JSON.stringify({ items });
};

// Set mask for Credit Card Number ==============
utils.ccMask = (numValidation, cardNumber) => {

  const num = cardNumber.replace(/(\-)/g, '');
  let mask = cardNumber;

  if (numValidation.card) {
    const offsets = [0].concat(numValidation.card.gaps).concat([num.length]);
    const components = [];
    let start;
    let end;

    for (let i = 0; offsets[i] < num.length; i++) {
      start = offsets[i];
      end = Math.min(offsets[i + 1], num.length);
      components.push(num.substring(start, end));
    }
    mask = components.join('-');
  }

  return mask;
};

// Check if element contains className ==========
utils.hasClass = (el, className) => {

  if (el.classList) {
    return el.classList.contains(className);
  }

  return !!el.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
};

// Adds a className to an element ===============
utils.addClass = (el, className) => {

  if (el.classList) {
    el.classList.add(className);
  } else if (!utils.hasClass(el, className)) {
    el.className += ` ${className}`;
  }
};

// Removes a className to an element ============
utils.removeClass = (el, className) => {

  if (el.classList) {
    el.classList.remove(className);
  } else if (utils.hasClass(el, className)) {
    const reg = new RegExp('(\\s|^)' + className + '(\\s|$)');

    el.className = el.className.replace(reg, ' ');
  }
};

// Check if valid JSON string ===================
utils.isJsonString = (str) => {

  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }

  return true;
};

// Debounce =====================================
utils.debounce = (fn, delay) => {
  let timer = null;

  return function ret() {
    const self = this;
    const args = arguments;

    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(self, args);
    }, delay);
  };
};

// String Replacer =====================================
utils.stringReplacer = (format, a, b, c, d, e, f) => {
  const args = [a, b, c, d, e, f];
  let argIndex = 0;

  return format.replace(/%s/g, () => {
    return args[argIndex++];
  });
};

// Object compare nested ===============================
utils.compareObj = (obj1, obj2) => {
  // Loop through properties in object 1
  for (const p in obj1) {
    // Check property exists on both objects
    if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) {
      return false;
    }

    switch (typeof (obj1[p])) {
      // Deep compare objects
      case 'object':
        if (!utils.compareObj(obj1[p], obj2[p])) {
          return false;
        }
        break;
      // Compare function code
      case 'function':
        if (typeof (obj2[p]) === 'undefined' || (p !== 'compare' && obj1[p].toString() !== obj2[p].toString())) {
          return false;
        }
        break;
      // Compare values
      default:
        if (obj1[p] !== obj2[p]) {
          return false;
        }
    }
  }

  // Check object 2 for any extra properties
  for (const p in obj2) {
    if (typeof (obj1[p]) === 'undefined') {
      return false;
    }
  }

  return true;
};

utils.ampmFormat = (time) => {
  const minutes = time.split(':')[1];
  let hours = parseInt(time.split(':')[0], 10);
  let ampmSuffix = 'AM';
  let resp = '';

  if (hours > 12) {
    hours -= 12;
    ampmSuffix = 'PM';
  } else if (hours === 12) {
    ampmSuffix = 'PM';
  } else if (hours === 0) {
    hours = 12;
  }

  if (hours <= 9) {
    hours = `0${ hours }`;
  }

  resp = `${ hours }:${ minutes } ${ ampmSuffix }`;

  return resp;
};

utils.questionToNaturalLanguage = (question) => {
  const questions = {
    'Has Tranquility Tubs': 'Tranquility Tubs',
    'Free access to nearby Sandals': 'Free access to nearby Sandsls',
    'Has Skypool Suites': 'Skypool Suites',
    'Has a private cove beach': 'Private cove beach',
    'Has wheelchair accessibility option': 'Wheelchair accessibility option',
    'Has a very long stretch of beach': 'Very long stretch of beach',
    'Has Over-the-Water Bungalows': 'Over-the-Water Bungalows',
    'Has active nightlife nearby': 'Active nightlife nearby',
    'Has Over-theWater Wedding Chapel': 'Over-the-Water Wedding Chapel',
    'Has an offshore island': 'Offshore island',
    'Has a casino nearby': 'Casino nearby',
    'Has rooftop pool': 'Rooftop pool',
    'Has its own golf course': 'Own golf course',
    'Has bowling alley': 'Bowling alley',
    'Has lush tropical gardens': 'Lush tropical gardens',
    'Has Swim-up Suites': 'Swim-up Suites',
    'Has rooms with private pools': 'Rooms with private pools',
    'Has Rondoval Suites': 'Rondoval Suites',
    'Includes waterskiing': 'Includes waterskiing',
    'Is in a more secluded location': 'More secluded location',
    'Is larger in area': 'Larger in area',
    'Is lively and social': 'Lively and social',
    'Is mostly quiet and restful': 'Mostly quiet and restful',
    'Is smaller in size, more intimate': 'Smaller in size, more intimate'
  };

  return (questions[question] || question);
};

utils.isABTastyVariation = (variationName) => {
  // Find div added by ABTasty variation of the quickquoter
  return document && !!document.getElementById(variationName);
};


// Export utils =================================

export default utils;

// Export utils methods =================================
export const persist = utils.persist;
export const capPhrase = utils.capPhrase;
export const formatMoney = utils.formatMoney;
export const roundNumber = utils.roundNumber;
export const rand = utils.rand;
export const numberWithCommas = utils.numberWithCommas;
export const ordinalSuffixOf = utils.ordinalSuffixOf;
export const searchJSON = utils.searchJSON;
export const nullValidator = utils.nullValidator;
export const classHelper = utils.classHelper;
export const toParam = utils.toParam;
export const getLocalStorageCart = utils.getLocalStorageCart;
export const setLocalStorageCart = utils.setLocalStorageCart;
export const ccMask = utils.ccMask;
export const hasClass = utils.hasClass;
export const addClass = utils.addClass;
export const removeClass = utils.removeClass;
export const isJsonString = utils.isJsonString;
export const debounce = utils.debounce;
export const stringReplacer = utils.stringReplacer;
export const formatOnly = utils.formatOnly;
export const ampmFormat = utils.ampmFormat;
export const questionToNaturalLanguage = utils.questionToNaturalLanguage;
export const isABTastyVariation = utils.isABTastyVariation;



// WEBPACK FOOTER //
// ./js/modules/utils.js